const partners = angular.module('partners', [])

partners.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.partners',
            url: '/partners',
            params: { showGlobalLoading: { dynamic: true, value: true }},
            component: 'partners.partnersComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);